import payment from './payment';
import order from './order';
import product from './product';
import shop from './shop';

export default {
  shop,
  payment,
  order,
  product,
};
